export const EINVOICING_NETWORK_TYPE = {
    PEPPOL: 'peppol',
} as const;

export type EinvoicingNetworkType = Enum<typeof EINVOICING_NETWORK_TYPE>;
